import { defineStore } from 'pinia'
import UsersService from '../services/users'
import type { IUserAssets, UserLevel, UserProfile } from '../types/users'
import { hasPremiumAccess } from '../constants/levels'

interface UserProfileState {
  profile: UserProfile | null
  loading: boolean
}

export const useUserProfileStore = defineStore('userProfile', {
  state: (): UserProfileState => ({
    profile: null,
    loading: false,
  }),

  getters: {
    avatarSignedUrl: (state) => state.profile?.assets?.avatar?.signedUrl || '',
    level: (state): UserLevel | null => state.profile?.level || null,
    isPremium: (state) => hasPremiumAccess(state.profile?.level),
  },

  actions: {
    async fetchProfile(userId: string) {
      this.loading = true
      try {
        const response = await UsersService.get(userId)
        this.profile = response.data
      } catch (error) {
        console.error('Error loading user profile:', error)
      } finally {
        this.loading = false
      }
    },

    async patchProfile(userId: string, assets: IUserAssets) {
      const response = await UsersService.patchProfile(userId, { assets })
      this.profile = response.data
      return response.data as UserProfile
    },

    clear() {
      this.profile = null
    },
  },
})
